/**
 *  Custom lookup reducers that restrict values based on other filter selections.
 */
import applyReducer from '../applyReducer';
import dependentFilterReducerFactory from '../factories/dependentFilterReducerFactory';
import issueConstants from '../../constants/issueConstants';

/**
 *  issue filters
 */
const jfiReducer = dependentFilterReducerFactory('jobFilterIssue', 'job', {
  assignedJobsOnly: true,
  searchJobNumberOnly: true,
  filters: {
    closed: '0'
  }
}, ['issueItem', 'issueItemOther', 'reportType', 'report', 'assignedTo'], issueConstants.INDEX_SUCCESS);
export const jobFilterIssue = applyReducer(jfiReducer.reducers, jfiReducer.initState);
const assignedToFilterIssueReducer = dependentFilterReducerFactory('assignedToFilterIssue', null, {
  paging: null,
  status: 1
}, ['issueItem', 'issueItemOther', 'job', 'report', 'reportType'], issueConstants.INDEX_SUCCESS);
export const assignedToFilterIssue = applyReducer(assignedToFilterIssueReducer.reducers, assignedToFilterIssueReducer.initState);
const rfiReducer = dependentFilterReducerFactory('reportFilterIssue', 'report', {
  reportsWithIssues: true
}, ['issueItem', 'issueItemOther', 'job', 'reportType', 'assignedTo'], issueConstants.INDEX_SUCCESS);
export const reportFilterIssue = applyReducer(rfiReducer.reducers, rfiReducer.initState);
const rtfiReducer = dependentFilterReducerFactory('reportTypeFilterIssue', null, {
  paging: null
}, ['issueItem', 'issueItemOther', 'job', 'report', 'assignedTo'], issueConstants.INDEX_SUCCESS);
export const reportTypeFilterIssue = applyReducer(rtfiReducer.reducers, rtfiReducer.initState);